import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTag } from '@fortawesome/pro-light-svg-icons'

import { Box, Button } from '@domain-group/suit-theme'

import useTagSelector from './hooks/useTagSelector'

interface TagSelectorProps {
  boxProps?: object,
  callbacks: {
    updateTags: (tags: string[]) => void,
  },
  filters: {
    agency_id: number,
  },
  selectedTags: string[],
}

const TagSelector = (props: TagSelectorProps) => {
  const {
    boxProps,
    callbacks: {
      updateTags,
    },
    filters,
    selectedTags: initSelectedTags,
  } = props

  const tagSelectorPayload = useTagSelector({
    callbacks: {
      updateTags,
    },
    filters,
    selectedTags: initSelectedTags,
  })

  const {
    callbacks: {
      setState,
      toggleTag,
    },
    editing,
    filteredAgencyTags,
    selectedTags,
  } = tagSelectorPayload

  return (
    <Box
      alignItems="center"
      border="1px dashed"
      borderColor="lineColor"
      borderRadius="5px"
      padding="medium"
      {...boxProps}
    >
      {editing && (
        <>
          {filteredAgencyTags.map(agencyTag => (
            <Button
              // @ts-expect-error TS2345
              buttonStyle={selectedTags.includes(agencyTag.title) ? 'primaryEdit' : 'secondaryUtility'}
              key={agencyTag.id}
              marginRight="small"
              onClick={() => toggleTag(agencyTag.title)}
              size="small"
              width="auto"
            >
              {agencyTag.title}
            </Button>
          ))}

          {/* TODO - Show Modal to create AgencyTag */}
          {/* <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            size="small"
            width="auto"
          >
            New Tag
          </Button> */}
        </>
      )}

      {!editing && (
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faTag} />}
          onClick={() => setState({ editing: !editing })}
          marginLeft="auto"
          size="small"
          width="auto"
        >
          Add Tags
        </Button>
      )}
    </Box>
  )
}

export default TagSelector
